export { default as Login } from './Login';
export { default as Register } from './Register';
export { default as PasswordChange } from './PasswordChange';
export { default as PasswordRecovery } from './PasswordRecovery';
export { default as RegistrationSuccess} from './RegistrationSuccess';
export { default as ActivationConfirm} from './ActivationConfirm'